// extracted by mini-css-extract-plugin
module.exports = {"win-card-box":"g1","winCardBox":"g1","win-card-btn-detail":"g2","winCardBtnDetail":"g2","win-card-dec":"g3","winCardDec":"g3","win-card-name":"g4","winCardName":"g4"};